import { PayloadAction } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IForm } from 'core-components/classes/models/IForm'

import { ActionHelper } from '../../classes/helpers/ActionHelper'
import { mapActionsFromCrud } from '../../services/mapping/mapActionFromCrud'
import { IOnboardingState, IRequestActionParams } from '../models'

/* getActionsRequest */
export const getActionsPending = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IRequestActionParams }>
) => {
  const { meta } = action

  state.actionsData.meta = meta
  state.actionsData.status = RequestStatus.PENDING
  state.actionsData.message = ''
}

export const getActionsRejected = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IRequestActionParams }>
) => {
  const { meta } = action

  state.actionsData.meta = meta
  state.actionsData.status = RequestStatus.REJECTED
  state.actionsData.message = action.payload as string
}

export const getActionsFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<IForm | null, string, { arg: IRequestActionParams }>
) => {
  const { meta, payload } = action

  state.actionsData.meta = meta
  state.actionsData.status = RequestStatus.FULFILLED
  state.actionsData.message = ''
  if (payload) {
    state.actionsData.data = ActionHelper.sortActions(mapActionsFromCrud(payload.actions))
  }
}

/* getParentActionsRequest */
export const getParentActionsPending = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IRequestActionParams }>
) => {
  state.actionsData.status = RequestStatus.PENDING
  state.actionsData.message = ''
}

export const getParentActionsRejected = (
  state: IOnboardingState,
  action: PayloadAction<unknown, string, { arg: IRequestActionParams }>
) => {
  state.actionsData.status = RequestStatus.REJECTED
  state.actionsData.message = action.payload as string
}

export const getParentActionsFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<IForm | null, string, { arg: IRequestActionParams }>
) => {
  const { payload } = action

  state.actionsData.status = RequestStatus.FULFILLED
  state.actionsData.message = ''
  if (payload && payload.actions && payload.actions.length) {
    let parentActions = ActionHelper.sortActions(mapActionsFromCrud(payload.actions))
    parentActions = parentActions.map((el) => ({
      ...el,
      EntryId: -el.EntryId,
      Name: `${el.Name}(From Parent Request)`,
      Process: `${el.Process}(From Parent Request)`,
      LinkToAnotherRequest: {
        rid: el.RequestId,
        EntryId: el.EntryId,
      },
    }))
    state.actionsData.data = [...state.actionsData.data, ...parentActions]
  }
}
